/**
 * [#916 reposicionamento, decisão do Filipe] O `<SeletorEstabelecimento>` (header do `AppShell`)
 * só faz sentido em telas cujo dado exibido muda conforme a unidade ativa — as demais ficam
 * limpas. Lista de ALLOWLIST (não denylist): rota nova nasce SEM o seletor até entrar aqui de
 * propósito — mesmo espírito fail-closed já usado no RBAC deste projeto (ADR-069), aplicado a
 * uma decisão de UI em vez de permissão.
 *
 * Critério usado para decidir cada entrada: a PÁGINA lê `useEstabelecimentoAtivoStore` de
 * verdade (dado muda com a unidade) — não "pertence ao mesmo item de menu". Por isso
 * `/financeiro/titulos`/`/financeiro/contas` entram mas `/financeiro/plano-de-contas` e
 * `/financeiro/centro-de-custo` (DEFINIÇÃO tenant-wide, ADR-030) não — mesmo as duas famílias
 * vivendo sob "Financeiro" no menu. Mesma lógica excluiu `/catalogo`(ItemCatalogo/Categoria são
 * tenant-wide, ADR-030) e `/settings/automacoes/templates-atendimento` (não lê o store, ao
 * contrário do `/settings/automacoes` que o pai desta rota lê).
 *
 * Com `/comercial/crm`/`/comercial/campanhas`: o prefixo cobre também as sub-rotas de
 * drill-down (`/comercial/crm/contatos/:id`, `/comercial/campanhas/:id`) de propósito — são a
 * MESMA tela/fluxo, só com um painel a mais aberto; esconder e reaparecer o seletor ao navegar
 * pra dentro seria um piscar sem propósito, não uma tela nova.
 */
const PREFIXOS_COM_SELETOR: readonly string[] = [
  '/dashboard',
  '/agenda',
  '/comercial/crm',
  '/comercial/inbox',
  '/comercial/campanhas',
  '/financeiro/contas',
  '/financeiro/titulos',
  // [AB#1215] Pagamentos (Agenda | Lotes) lê a unidade ativa; as rotas antigas só redirecionam.
  '/financeiro/pagamentos',
  // [AB#1175] Conciliação e Cobrança listam as contas da unidade ativa (Conta pertence a UM estabelecimento, ADR-030).
  '/financeiro/conciliacao',
  '/financeiro/cobranca',
  '/contabilidade/fechamento-fiscal',
  '/contabilidade/parametros',
];

export function deveMostrarSeletorEstabelecimento(pathname: string): boolean {
  // [exceção pontual] `/settings/automacoes` é path exato — a sub-rota
  // `/settings/automacoes/templates-atendimento` NÃO lê a unidade ativa (ver docstring acima),
  // então não pode herdar o seletor só por compartilhar o prefixo com o pai.
  if (pathname === '/settings/automacoes') return true;
  return PREFIXOS_COM_SELETOR.some(
    (prefixo) => pathname === prefixo || pathname.startsWith(`${prefixo}/`),
  );
}
